import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-follow-list',
  templateUrl: './board-follow-list.component.html',
  styleUrls: ['./board-follow-list.component.scss']
})
export class BoardFollowListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
